import type { SweetAlertOptions } from 'sweetalert2';

// sweetalert2を動的インポート（重いライブラリのため）
let sweetalertModule: typeof import('sweetalert2') | null = null;
let baseInstance: ReturnType<typeof import('sweetalert2').default.mixin> | null = null;
let toastInstance: ReturnType<typeof import('sweetalert2').default.mixin> | null = null;

// sweetalert2を遅延読み込み
const loadSweetAlert = async () => {
  if (!sweetalertModule) {
    sweetalertModule = await import('sweetalert2');
    const sweetalert = sweetalertModule.default;

    // ベースとなるスタイルを調整
    baseInstance = sweetalert.mixin({
      confirmButtonColor: 'var(--color-primary)',
      cancelButtonColor: '#999999',
      denyButtonColor: '#cc3333',
      confirmButtonText: 'OK',
      cancelButtonText: 'キャンセル',
      customClass: {
        popup: 'custom-swal-popup',
        actions: 'custom-swal-actions',
        confirmButton: 'custom-swal-confirm-button',
        cancelButton: 'custom-swal-cancel-button',
      },
      didOpen: () => {
        // data-testidを追加
        const confirmButton = document.querySelector('.custom-swal-confirm-button');
        const cancelButton = document.querySelector('.custom-swal-cancel-button');
        if (confirmButton) {
          confirmButton.setAttribute('data-testid', 'swal-confirm-button');
        }
        if (cancelButton) {
          cancelButton.setAttribute('data-testid', 'swal-cancel-button');
        }
      },
    });

    //トースト
    toastInstance = baseInstance.mixin({
      toast: true,
      position: 'top',
      padding: '0.5rem 1rem',
      showConfirmButton: false,
      timer: 3000,
    });
  }
  return {
    sweetalert: sweetalertModule!.default,
    base: baseInstance!,
    Toast: toastInstance!,
  };
};

const fire = async (options: SweetAlertOptions) => {
  const { sweetalert } = await loadSweetAlert();
  return sweetalert.fire(options);
};

/**
 * 確認
 * @returns
 */
const confirm = async (options: {
  title?: string;
  text?: string;
  confirmButtonText?: string;
}) => {
  const { base } = await loadSweetAlert();
  return base.fire({
    title: options?.title || '確認',
    html: options?.text || '操作を続行します。よろしいですか？',
    confirmButtonText: options?.confirmButtonText || 'OK',
    showCancelButton: true,
  });
};

/**
 * アラート
 * @returns
 */
const alert = async (options: { text: string } | { html: string }) => {
  const { base } = await loadSweetAlert();
  return base.fire({
    title: ' ',
    confirmButtonText: '閉じる',
    text: 'text' in options ? options.text : undefined,
    html: 'html' in options ? options.html : undefined,
  });
};

/**
 * 正常完了トースト
 * @returns
 */
const toastSuccess = async ({ title = '登録に成功しました' } = {}) => {
  const { Toast } = await loadSweetAlert();
  return Toast.fire({
    icon: 'success',
    title: title,
  });
};

/**
 * 入力エラー
 * @returns
 */
const invalid = async () => {
  const { base } = await loadSweetAlert();
  return base.fire({
    title: ' ',
    confirmButtonText: 'OK',
    text: '入力内容を確認してください。',
  });
};

/**
 * エラーメッセージ
 * @returns
 */
const messages = async (options: { messages: Array<string> }) => {
  const { base } = await loadSweetAlert();
  return base.fire({
    title: ' ',
    confirmButtonText: 'OK',
    html: options.messages.join('<br>'),
  });
};

export const swal = {
  fire,
  confirm,
  alert,
  invalid,
  messages,
  toastSuccess,
};
